<template>
	<competition-assignments-page url="/v1/views/results"
								  :title="t('label.results')"
								  :feature-title="t('view.results.title')"
								  :feature-description="t('view.results.description')"
								  :community-feature-title="t('view.results.community.title')"
								  :community-feature-description="t('view.results.community.description')"
								  feature-image="/features/athletes/results.svg"
								  :item-link="{to: '/competition-planner', text: t('label.competition_planner')}" for-past>
		<template #assignment_skeletons>
			<participation-preview-skeleton with-ranks />
		</template>
	</competition-assignments-page>
</template>

<script setup lang="ts">
const {t} = useI18n();

useMeta({
	title: t('view.results.title'),
	description: t('view.results.description'),
})

</script>

